
export enum TipoRelatorioEnum {
  Matriz = 'Matriz',
  HoraMarca = 'HoraMarca',
  RegistroPonto = 'RegistroPonto',
  Performance = 'Performance',
  PerformanceFotos = 'PerformanceFotos',
  PerformanceCliente = 'PerformanceCliente',
  PerformanceFotosCliente = 'PerformanceFotosCliente',
  ImportadorRoteiros = 'ImportadorRoteiros',
  ImportadorGeral = 'ImportadorGeral',
}
